import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import CommonConfig from '../../../utils/constant';
import Loader from "../../Shared/Loader/Loader";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { RadioButton } from 'primereact/radiobutton';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { useNavigate } from 'react-router-dom';

const StudentList = (props) => {
	const navigate = useNavigate();
	const { catchResponse } = useCatchResponse();
	const [securityUserID, setSecurityUserID] = useState("");
	const [visible, setVisible] = useState(false);
	const [studentsList, setStudentsList] = useState([]);
	const [selectedHouse, setSelectedHouse] = useState([]);
	const [isRandom, setIsRandom] = useState(false);
	const [orderByValue, setOrderByValue] = useState('');
	const [selectedStudents, setSelectedStudents] = useState([]);
	const [houseList, setHouseList] = useState([]);
	const [selectedHouseErr, setSelectedHouseErr] = useState(false);
	const [selectedHouseErrText, setSelectedHouseErrText] = useState('');

	useEffect(() => {
		const loginData = CommonConfig.loginData();
		setSecurityUserID(loginData?._id);
		GetClassStudentsList();
		GetHouseList(loginData?._id);
	}, []);

	const GetClassStudentsList = async () => {
		try {
			let data = {
				ClassId: props?.location?.state?.classId
			}
			Loader.show();
			await api.post(APIConstant.path.GetClassConfigStudentDetail, data).then(async response => {
				let res = response;
				if (res.success) {
					let sortedList = res?.data ? res?.data?.sort((a, b) => a?.RollNo - b?.RollNo) : [];
					setStudentsList(sortedList);
					setSelectedStudents(res?.data);
					Loader.hide();
				}
			}).catch(err => {
				Loader.hide();
				console.log(err);
				catchResponse(err);
			});
		} catch (err) {
			console.log(err);
			catchResponse(err);
		}
	}

	const onCancel = () => {
		setVisible(false);
		setSelectedHouseErr(false);
		setSelectedHouseErrText('');
		setSelectedHouse([]);
		setOrderByValue('');
		setIsRandom('');
	};

	const GetHouseList = async (id) => {
		try {
			let data = {
				UserID: id,
			}
			await api.post(APIConstant.path.getHouseList, data).then(async response => {
				let res = response;
				if (res.success) {
					setHouseList(res?.data?.filter((y) => y?.Status === 'Active')?.map(x => ({
						...x,
						label: x?.HouseName,
						value: x._id
					})));
					Loader.hide();
				}
			}).catch(err => {
				Loader.hide();
				console.log(err);
				catchResponse(err);
			});
		} catch (err) {
			console.log(err);
			catchResponse(err);
		}
	}

	const assignhouse = async (e) => {
		try {
			Loader.show();
			setSelectedHouseErr(false);
			setSelectedHouseErrText('');

			let studentsToAssign = [...selectedStudents];

			if (orderByValue === 'ByNameWise') {
				studentsToAssign.sort((a, b) => a?.Name?.localeCompare(b?.Name));
			}

			if (!orderByValue && (!selectedHouse?.length || selectedHouse.length === 0)) {
				setSelectedHouseErr(true);
				setSelectedHouseErrText('Please select house');
				Loader.hide();
				return;
			}

			for (let i = 0; i < studentsToAssign.length; i++) {
				const student = studentsToAssign[i];

				let data = {
					AdmissionId: student?.AdmissionId,
					UserId: student?.id,
				};

				if (orderByValue === 'ByNameWise') {
					data.RollNo = i + 1;
				}
				if (selectedHouse.length) {
					data.House = getHouseAssignment(student, selectedHouse, studentsToAssign.length);
				}

				await postAdmissionDetail(data);
			}

			Loader.hide();
			onCancel();
			GetClassStudentsList();

		} catch (err) {
			console.error(err);
			Loader.hide();
			Toast.error({ message: 'Error during house assignment' });
			catchResponse(err);
		}
	};

	const getHouseAssignment = (() => {
		let assignedIndex = 0;
		let shuffledHouses = [];

		return (student, selectedHouse, totalStudents) => {
			if (selectedHouse.length === totalStudents) {
				if (assignedIndex === 0) {
					shuffledHouses = [...selectedHouse].sort(() => Math.random() - 0.5);
				}
				const house = shuffledHouses[assignedIndex];
				assignedIndex++;
				return house;
			}

			if (selectedHouse.length === 1) return selectedHouse[0];

			const half = Math.floor(selectedHouse.length / 2);
			const isMale = student?.Gender === 'male';
			const isFemale = student?.Gender === 'female';

			if (isMale) {
				return selectedHouse[Math.floor(Math.random() * half)];
			}
			if (isFemale) {
				return selectedHouse[half + Math.floor(Math.random() * (selectedHouse.length - half))];
			}
			return selectedHouse[Math.floor(Math.random() * selectedHouse.length)];
		};
	})();

	const postAdmissionDetail = async (data) => {
		try {
			const res = await api.post(APIConstant.path.AddAdmissionDetail, data);
			if (res.success) {
				Toast.success({ message: res.message });
			} else {
				Toast.error({ message: res.message });
			}
		} catch (err) {
			console.error(err);
			Toast.error({ message: 'Error assigning house' });
		}
	};


	const handleRowReorder = (event) => {
		const updatedValues = event.value.map((item, index) => ({
			...item,
			RollNo: index + 1,
		}));
		setStudentsList([...updatedValues]);
		setSelectedStudents([...updatedValues]);
	};

	const handleHouseChange = (studentId, newHouse) => {
		setStudentsList((prevList) =>
			prevList.map((student) =>
				student?.id === studentId
					? { ...student, HouseId: newHouse }
					: student
			)
		);
	};

	return (
		<div className="p-fluid">
			<div className='dialog-footer p-d-flex p-ai-center p-jc-between p-mb-2'>
				<h3 className='p-m-0'>Assign House</h3>
				<div className="dialog-footer p-d-flex p-ai-center p-jc-end">
					<Button label="Cancel" className="p-m-0 btn-text-action-secondary p-m-1" onClick={() => navigate('/class-configuration')} />
					<Button label="Assign" className="e-assign-btn btn-text-action-primary" onClick={() => setVisible(true)} />
				</div>
			</div>
			<hr className='p-m-0' />
			<DataTable value={studentsList} responsiveLayout="scroll" reorderableRows onRowReorder={handleRowReorder} selection={selectedStudents}
				onSelectionChange={(e) => setSelectedStudents(e.value)}
				selectionMode="multiple" className='custom-table'
				scrollHeight='calc(100vh - 200px)'
				size='small'>
				<Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
				<Column rowReorder header="#" />
				<Column field="SrNo" body={(rowData, options) => options.rowIndex + 1} header="Sr No." />
				<Column field="StudentId" header="Student ID" />
				<Column field="Name" header="Student Name" />
				<Column field="Email" header="Email" />
				<Column field="Gender" header="Gender" />
				<Column header="House" body={(rowData) => (
					<Dropdown
						id="houseDropdown"
						value={rowData?.HouseId}
						options={houseList}
						onChange={(e) => handleHouseChange(rowData?.id, e.target.value)}
						placeholder="Select a House"
						className="mr-2"
						display="chip"
						filter
						showClear
					/>
				)} />
				<Column field="RollNo" header="Roll No." />
			</DataTable>

			<Dialog
				header="Assign House"
				// className='dialog-popup'
				visible={visible}
				onHide={() => onCancel()}
				draggable={false}
				position="center"
				style={{ width: '30vw' }}
			>
				<div className='p-pb-4'>
					<div className="p-field">
						<div className='p-d-flex p-ai-center p-jc-between p-mb-2'>
							<label htmlFor="houseDropdown">Select House</label>
							<div>
								<Checkbox
									inputId="randomCheckbox"
									checked={isRandom}
									onChange={(e) => setIsRandom(e.checked)}
								/>
								<label htmlFor="randomCheckbox" style={{ marginLeft: '8px' }}>Random</label>
							</div>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '1px' }}>
							<MultiSelect
								id="houseDropdown"
								value={selectedHouse}
								options={houseList}
								onChange={(e) => setSelectedHouse(e.value)}
								placeholder="Select a House"
								className="mr-2 p-w-100"
								filter
								display="chip"
							/>
							<span className="error-msg" style={{ color: 'red' }}>
								{selectedHouseErr ? selectedHouseErrText : null}
							</span>
						</div>
					</div>

					<h3>Roll No.</h3>
					<div className='p-grid'>
						<div className="p-col-12 p-md-6 p-pt-2">
							<div className="">
								<RadioButton
									inputId="ByNameWise"
									name="ByNameWise"
									value="ByNameWise"
									checked={orderByValue === 'ByNameWise'}
									onChange={(e) => setOrderByValue(e.value)}
								/>
								<label htmlFor="ByNameWise"> ByNameWise</label>
							</div>
						</div>
						<div className="p-col-12 p-md-6 p-pt-2">
							<div className="">
								<RadioButton
									inputId="ByStudentID"
									name="byStudentID"
									value="ByStudentID"
									checked={orderByValue === 'ByStudentID'}
									onChange={(e) => setOrderByValue(e.value)}
								/>
								<label htmlFor="ByStudentID"> ByStudentID</label>
							</div>
						</div>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
					</div>

					<div className='p-d-flex p-ai-center p-jc-end'>
						<Button
							label="ASSIGN"
							className="p-y-0 p-ml-0 p-mr-2 e-assign-btn"
							onClick={(e) => assignhouse()}
						/>
						<Button
							label="RESET"
							className="p-m-0 btn-dialog-delete"
							onClick={onCancel}
						/>
					</div>
				</div>
			</Dialog>
		</div>
	);
};

export default StudentList;
